import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'
import LeadsHeader from '../components/leads/VersionHeader'
import LanguageTable from '../components/leads/VersionCreate'
import Footer from '../components/shared/Footer'

const VersionCreate = () => {
    return (
        <>
            <PageHeader>
               
            </PageHeader>
            <div className='main-content'>
                <div className='row'>
                    <LanguageTable />
                </div>
            </div>
            
        </>
    )
}

export default VersionCreate